import { useRef } from "react";
import "./reports.css";

interface ReportPrintFrameProps {
  url: string;
}

// Invisible full-size frame that loads the report PDF and opens the browser print dialog on the
// current page. Not display:none / 0x0: browsers skip rendering (and print blank) for those.
const ReportPrintFrame = ({ url }: ReportPrintFrameProps) => {
  const frameRef = useRef<HTMLIFrameElement>(null);

  const printReport = () => {
    const frameWindow = frameRef.current?.contentWindow;
    if (!frameWindow) return;
    const previouslyFocused = document.activeElement as HTMLElement | null;
    try {
      frameWindow.focus();
      frameWindow.print();
    } catch {
      // Scripted print of an embedded PDF can be blocked by some browsers; nothing else to do here.
    } finally {
      // Focus moved into the invisible PDF viewer to print; give it back so keyboard
      // scrolling/shortcuts keep acting on the page afterwards.
      if (previouslyFocused?.isConnected && previouslyFocused !== document.body) {
        previouslyFocused.focus();
      } else {
        window.focus();
      }
    }
  };

  return (
    <iframe
      ref={frameRef}
      className="report-print-frame"
      title="Print Report"
      aria-hidden="true"
      tabIndex={-1}
      src={url}
      onLoad={printReport}
    />
  );
};

export default ReportPrintFrame;
